<template>

  <div class="container overflow-hidden ">
    <div class="col">
      <el-dialog :visible.sync="dialogTableVisible">
        <div>
          <div class="col">
            <el-tag size="medium">
              recomendado
            </el-tag>
          </div>
          <el-button class="item">
            JS
          </el-button>
        </div>
        <el-divider />
        <h2 class="ant-typography">
          Código JS
        </h2>
        <div class="col">

          <div class="row justify-content-end">
            <div class="col-1">
              <i
                class="el-icon-document-copy"
                @click="copiarTexto()"
              />
            </div>

          </div>

          <div
            id="content___1YRKM"
            class="player-card-modal-textarea "
          >
            <textarea
              id="texto"
              readonly=""
              class="ant-input"
            >

              &lt;div class="container" id="vid_{{ idVsl }}" style="position:relative;width:100%;padding: 56.25% 0 0;"&gt;
              &lt;img id="thumb_{{ idVsl }}" src="{{ frameVsl }}" style="position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;display:block;"&gt;
              &lt;/div&gt;
              &lt;script type="text/javascript" id="scr_{{ idVsl }}">var s=document.createElement("script");s.id="teste", s.src="https://vsl-booster-prod.s3.amazonaws.com/min/script.min.js",s.type="module", s.async=!0,document.head.appendChild(s);
              &lt;/script&gt;

           </textarea>
          </div>

        </div>
        <span
          slot="footer"
          class="dialog-footer"
        >
          <el-button @click="dialogTableVisible = false">Cancel</el-button>
        </span>
      </el-dialog>
    </div>

    <div class="row gx-5">
      <div class="col-3">
        <el-menu
          default-active="2"
          class="el-menu-vertical-demo custom-menu"
        >
          <el-button
            type="text"
            icon="el-icon-arrow-left"
            style="color: black;"
            @click="Voltar"
          >
            Voltar para Meus Vídeos
          </el-button>
          <el-menu-item index="2">
            <i class="el-icon-document" />
            <span slot="title">Detalhes</span>
          </el-menu-item>
          <el-menu-item
              id="tela-editar-video"
            index="3"
            @click="customizacao"
          >
            <i class="el-icon-edit-outline" />
            <span slot="title">Editar</span>
          </el-menu-item>
          <el-menu-item
              id="tela-analytics-video"
            index="4"
            @click="analitycs"
          >
            <i class="el-icon-pie-chart" />
            <span slot="title">Anailytics</span>
          </el-menu-item>
          <el-menu-item
              id="tela-Download-video"
            index="5"
            @click="download"
          >
            <i class="el-icon-download" />
            <span slot="title">Download</span>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="col-9 player">
        <div class="container bg-white d-flex flex-column ml-1 ">
          <p class="p-2 nome_video d-flex justify-content-between align-items-center">
            <span>{{ vsl[0].vsl_name }}&nbsp;
              <feather-icon
                icon="Edit3Icon"
                size="18"
                stroke="black"
                class="mr-1"
                @click="esconderNome();ajusteCSS();"
              />
            </span>
            <b-button
              id="embed-datalhes-video"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              @click="Embed"
            >
              <feather-icon
                icon="CodeIcon"
                class="mr-50"
              />
              <span class="align-middle">Embed</span>
            </b-button>
          </p>
          <form
            class="form_edit p-2"
            hidden
          >

            <div class="row">

              <div class="form-floating md-2">
                <input
                  v-model="vsl[0].vsl_name"
                  class="form-control"
                  placeholder="Leave a comment here"
                >
              </div>
            </div>

            <div class="row mt-1">

              <div class="form-floating md-2">
                <textarea
                  id="floatingTextarea"
                  v-model="vsl[0].vsl_description"
                  class="form-control"
                  placeholder="Descrição"
                />
                <label for="floatingTextarea" />
              </div>
            </div>
            <div class="row mt-1">

              <div class="form-floating md-2">
                <input
                  v-model="vsl[0].vsl_tag"
                  class="form-control"
                  placeholder="Tag"
                >
              </div>
            </div>
            <div class="md-2">
              <button
                type="button"
                class="btn btn-danger mt-2 ml-0"
                @click="updateInfoVSL();"
              >
                Salvar
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary  mt-2 ml-1"
                @click="cancelar();voltarCSS();"
              >
                Voltar
              </button>
            </div>
          </form>
        </div>
        <div class="container mt-2">
          <video
            muted
            class="player_my_video viewer"
            :poster="dadosVideo.thumb.thumbStart"
            :src="dadosVideo.URL"
            type="video/mp4"
          />
          <div
            v-if="dadosVideo.autoPlayer.autoPlayerAtivo"
            class="iniciar center"
            :style="'background-color:' + dadosVideo.autoPlayer.bgColorAuto"
          >
            <h2
              class="m-4"
              :style="'color:' + dadosVideo.autoPlayer.textColorAuto"
              _msthash="1354873"
              _msttexthash="308412"
            >{{ dadosVideo.autoPlayer.textBottom }}</h2>
            <div class="loader"><span class="stroke" /><span class="stroke" /><span
              class="stroke"
            /><span class="stroke" /><span class="stroke" /><span
              class="stroke"
            /><span class="stroke" /><span class="stroke" /><span
              class="stroke"
            /><span class="stroke" /><span class="stroke" /><span
              class="stroke"
            />
            </div>
            <h2
              class="mt-0"
              :style="'color:' + dadosVideo.autoPlayer.textColorAuto"
              _msthash="1354874"
              _msttexthash="413270"
            >{{ dadosVideo.autoPlayer.textTop }}</h2>
          </div>
          <div
            v-if="dadosVideo.autoPlayer.autoPlayerAtivo === 0"
            class="playpause"
            :style="'background-color:' + getControls[0].controls_back_color"

            @click="togglePlay();"
          />
          <div
            class="playpausebg"
            :style="'background-image:url(' + dadosVideo.thumb.thumbPause + ');'"
            hidden
          />
          <div
            class="playEndedbg"
            :style="'background-image:url(' + dadosVideo.thumb.thumbEnd + ');'"
            hidden
          />
          <nav
            id="navega"
            class="player_my_controls"
          >

            <div
              v-if="getControls[0].controls_progress_bar === 1"
              class="progress"
              :style="'height:' + dadosVideo.barra.bar_hight + 'px;'"
            >
              <div
                class="progress_my_filled"
                :style="'background-color:' + dadosVideo.barra.bar_cor + ';flex-basis: 10.9778%;'"
              />
            </div>
            <button
              v-show="getControls[0].controls_bt_small_player === 1"
              class="player_my_button toggle"
              _msthash="1603160"
              _msttexthash="878514"
            >
              ▶
            </button>
            <button
              v-show="getControls[0].controls_retro_10s === 1"
              class="player_my_button button_retroceder "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  d="M0 0h24v24H0V0z"
                />
                <path
                  d="M11.99 5V1l-5 5 5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6h-2c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8zm-1.1 11h-.85v-3.26l-1.01.31v-.69l1.77-.63h.09V16zm4.28-1.76c0 .32-.03.6-.1.82s-.17.42-.29.57-.28.26-.45.33-.37.1-.59.1-.41-.03-.59-.1-.33-.18-.46-.33-.23-.34-.3-.57-.11-.5-.11-.82v-.74c0-.32.03-.6.1-.82s.17-.42.29-.57.28-.26.45-.33.37-.1.59-.1.41.03.59.1.33.18.46.33.23.34.3.57.11.5.11.82v.74zm-.85-.86c0-.19-.01-.35-.04-.48s-.07-.23-.12-.31-.11-.14-.19-.17-.16-.05-.25-.05-.18.02-.25.05-.14.09-.19.17-.09.18-.12.31-.04.29-.04.48v.97c0 .19.01.35.04.48s.07.24.12.32.11.14.19.17.16.05.25.05.18-.02.25-.05.14-.09.19-.17.09-.19.11-.32.04-.29.04-.48v-.97z"
                  fill="#FFF"
                  class="color000000 svgShape"
                />
              </svg>
            </button>
            <button
              v-show="getControls[0].controls_avan_10s === 1"
              class="player_my_button button_avancar"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path
                  d="M18.92 13c-.5 0-.91.37-.98.86-.48 3.37-3.77 5.84-7.42 4.96-2.25-.54-3.91-2.27-4.39-4.53C5.32 10.42 8.27 7 12 7v2.79c0 .45.54.67.85.35l3.79-3.79c.2-.2.2-.51 0-.71l-3.79-3.79c-.31-.31-.85-.09-.85.36V5c-4.94 0-8.84 4.48-7.84 9.6.6 3.11 2.9 5.5 5.99 6.19 4.83 1.08 9.15-2.2 9.77-6.67.09-.59-.4-1.12-1-1.12zm-8.02 3v-4.27h-.09l-1.77.63v.69l1.01-.31V16zm3.42-4.22c-.18-.07-.37-.1-.59-.1s-.41.03-.59.1-.33.18-.45.33-.23.34-.29.57-.1.5-.1.82v.74c0 .32.04.6.11.82s.17.42.3.57.28.26.46.33.37.1.59.1.41-.03.59-.1.33-.18.45-.33.22-.34.29-.57.1-.5.1-.82v-.74c0-.32-.04-.6-.11-.82s-.17-.42-.3-.57-.29-.26-.46-.33zm.01 2.57c0 .19-.01.35-.04.48s-.06.24-.11.32-.11.14-.19.17-.16.05-.25.05-.18-.02-.25-.05-.14-.09-.19-.17-.09-.19-.12-.32-.04-.29-.04-.48v-.97c0-.19.01-.35.04-.48s.06-.23.12-.31.11-.14.19-.17.16-.05.25-.05.18.02.25.05.14.09.19.17.09.18.12.31.04.29.04.48v.97z"
                  fill="#fff"
                  class="color000000 svgShape"
                />
              </svg>
            </button>
            <button
              v-show="getControls[0].controls_video_vol === 1"
              class="player_my_button button_volume"
            >
              <svg
                viewBox="0 0 24 24"
                width="20"
                height="20"
              >
                <path
                  fill="#fff"
                  d="M12 3.984v4.219l-2.109-2.109zM4.266 3l16.734 16.734-1.266 1.266-2.063-2.063q-1.547 1.313-3.656 1.828v-2.063q1.172-0.328 2.25-1.172l-4.266-4.266v6.75l-5.016-5.016h-3.984v-6h4.734l-4.734-4.734zM18.984 12q0-2.391-1.383-4.219t-3.586-2.484v-2.063q3.047 0.656 5.016 3.117t1.969 5.648q0 2.203-1.031 4.172l-1.5-1.547q0.516-1.266 0.516-2.625zM16.5 12q0 0.422-0.047 0.609l-2.438-2.438v-2.203q1.031 0.516 1.758 1.688t0.727 2.344z"
                />
              </svg>

            </button>

            <button
              v-show="getControls[0].controls_bt_screem === 1"
              class="player_my_button fullscreenbtn"
            >
              <svg
                viewBox="0 0 24 24"
                width="20"
                height="20"
              >
                <path
                  fill="#fff"
                  d="M14.016 5.016h4.969v4.969h-1.969v-3h-3v-1.969zM17.016 17.016v-3h1.969v4.969h-4.969v-1.969h3zM5.016 9.984v-4.969h4.969v1.969h-3v3h-1.969zM6.984 14.016v3h3v1.969h-4.969v-4.969h1.969z"
                />
              </svg>
            </button>
            <button
              v-show="getControls[0].controls_picture_in_picture === 1"
              class="player_my_button PictureInPicture"
            >
              <svg
                viewBox="0 0 24 24"
                width="20"
                height="20"
              >
                <path
                  fill="#fff"
                  d="M21 19.031v-14.063h-18v14.063h18zM23.016 18.984q0 0.797-0.609 1.406t-1.406 0.609h-18q-0.797 0-1.406-0.609t-0.609-1.406v-14.016q0-0.797 0.609-1.383t1.406-0.586h18q0.797 0 1.406 0.586t0.609 1.383v14.016zM18.984 11.016v6h-7.969v-6h7.969z"
                />
              </svg>
            </button>
          </nav>
        </div>

      </div>

    </div>
  </div>

</template>

<script>
import axios from 'axios'
import { BTabs, BTab, BButton } from 'bootstrap-vue'
import { Ripple } from 'vue-ripple-directive'
import { VslService, Vsl_Service } from '@/services/Vsl'
import VideoPlayerCustom from '@/components/analytics/VideoPlayerCustom'
import { ControlsService } from '@/services/Controls'
import router from '@/router'
import Editar from './Editar.vue'
import Detalhes from './Detalhes.vue'

const vslService = new Vsl_Service()

export default {
  components: {
    BTabs,
    BTab,
    BButton,
    Detalhes,
    Editar,
    VideoPlayerCustom,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      frameVsl: '',
      idVsl: '',
      dialogTableVisible: false,
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND,
      vslId: this.$route.params.vslId,
      options: {},
      vsl: [],
      autoPlayer: [],
      dadosVideo: [],
      control: [],
      playx: 'true',
    }
  },
  computed: {
    getControls() {
      console.log(this.control)
      return this.control
    },
  },

  async created() {
    try {
      const response = await VslService.getVsl(this.vslId)
      this.vsl = response.data
      const controle = await ControlsService.getControlVSL_Id(this.vslId)
      this.control = controle.data
      this.loading = false
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  beforeMount() {
    this.jsonPersonalizado()
  },
  beforeCreate() {
    this.$http.get('/perfil_geral').then(res => {
      this.options = res.data
    })
  },

  mounted() {
    this.vslobjId()
  },

  methods: {
    async vslobjId() {
      const vslObj = await vslService.getVslId(this.vslId)
      this.frameVsl = vslObj[0].vsl_frame
    },
    async Embed() {
      const idVsl = { id: router.currentRoute.params.vslId }
      this.idVsl = idVsl.id
      this.dialogTableVisible = true
    },
    copiarTexto() {
      const textoCopiado = document.getElementById('texto')
      textoCopiado.select()
      textoCopiado.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.$message({
        message: 'Código de embed JS copiado para área de transferência',
        type: 'success',
      })
    },
    jsonPersonalizado() {
      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/${this.vslId}`
      console.log('testeHost', url)
      fetch(url)
        .then(response => response.json())
        .then(data => {
          console.log(data.status)
          if (data.status == '1') {
            this.dadosVideo = data.json.find(item => String(item.id) === String(this.vslId))
            console.log(this.dadosVideo)
          } else {
            this.$message({
              type: 'danger',
              message: 'Não Identificamos o pagamento da sua assinatura, por favor regularize',
            })

            return this.$router.push('/Videos')
          }
        })
    },
    esconderNome() {
      const nome = document.querySelector('.nome_video')
      const formulario = document.querySelector('.form_edit')
      nome.setAttribute('hidden', '')
      formulario.removeAttribute('hidden')
    },
    ajusteCSS() {
      const iniciar = document.querySelector('.iniciar')
      const cor = iniciar.getAttribute('style')
      iniciar.setAttribute('style', `height:36%;${cor}top:53%;`)
    },
    voltarCSS() {
      const iniciar = document.querySelector('.iniciar')
      iniciar.removeAttribute('style')
      iniciar.setAttribute('style', `height:43%;background-color:${this.dadosVideo.autoPlayer.bgColorAuto};top:32%;`)
    },
    cancelar() {
      const nome = document.querySelector('.nome_video')
      const formulario = document.querySelector('.form_edit')
      formulario.setAttribute('hidden', '')
      nome.removeAttribute('hidden')
    },
    updateInfoVSL() {
      const options = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: `{"id_vsl":"${this.vslId}","vsl_name":"${this.vsl[0].vsl_name}","vsl_description":"${this.vsl[0].vsl_description}","vsl_tag":"${this.vsl[0].vsl_tag}"}`,
      }

      fetch(`${this.VUE_APP_HOST_API_BACKEND}/updateInfoVSL`, options)
        .then(response => response.json())
        .then(response => {
          if (response.affectedRows === 1) {
            this.$message({
              type: 'success',
              message: 'Salvo com sucesso',
            })
          } else {
            this.$alert('Não foi possivel alterar os dados')
          }
        })

        .catch(err => console.error(err))
    },
    togglePlay() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      const togglePausePlay = player.querySelector('.playpause')
      const togglePausePlaybg = player.querySelector('.playpausebg')
      const toggleEndedbg = player.querySelector('.playEndedbg')
      const iniciar = player.querySelector('.iniciar')

      if (video.ended) {
        console.log('PRIMEIRO')
        toggleEndedbg.setAttribute('hidden', '')
        console.log('togglePausePlay')
      }
      if (video.paused) {
        console.log('PRIMEIRO2')
        video.play()

        togglePausePlay.setAttribute('hidden', '')
        togglePausePlaybg.setAttribute('hidden', '')

        video.muted = false
      } else if (this.playx == 'true') {
        console.log('PRIMEIRO3')
        iniciar.style.visibility = 'hidden'
        video.muted = false
        video.load()
        this.playx = false
      } else {
        video.pause()

        console.log('pausado')
        togglePausePlay.removeAttribute('hidden')
        togglePausePlaybg.removeAttribute('hidden')
      }
    },
    avancar() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      video.currentTime += 10
    },

    retroceder() {
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')
      video.currentTime -= 10
    },
    toggleFullScreen() {
      const player = document.querySelector('.player')

      if (!document.fullscreenElement && !document.mozFullScreenElement
          && !document.webkitFullScreenElement && !document.msFullScreenElement) {
        if (player.requestFullscreen) {
          player.requestFullscreen()
        } else if (player.msRequestFullscreen) {
          player.msRequestFullScreen()
        } else if (player.mozRequestFullScreen) {
          player.mozRequestFullScreen()
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen()
        } else if (player.webkitRequestFullscreen) {
          player.webkitRequestFullscreen()
        }
      } else if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    },
    updateButton() {
      const player = document.querySelector('.player')
      const toggle = player.querySelector('.toggle')
      const icon = this.paused ? '▶' : '❚❚'
      console.log(icon)
      toggle.textContent = icon
    },
    handleProgress() {
      var percentReal
      let
        percentFake
      const player = document.querySelector('.player')
      const video = player.querySelector('.player_my_video')

      const progressBar = player.querySelector('.progress_my_filled')
      const togglePausePlay = player.querySelector('.playpause')
      const toggleEndedbg = player.querySelector('.playEndedbg')

      if (video.ended) {
        toggleEndedbg.removeAttribute('hidden')
        togglePausePlay.removeAttribute('hidden')
        console.log('VIDEO FINALIZADO...', video.ended)
      }
      percentFake = (video.currentTime / 150) * 100
      if (percentFake <= 50) {
        var percentReal = (video.currentTime / 150) * 100
        progressBar.style.flexBasis = `${percentFake}%`
      } else {
        //  console.log(video.duration);
        var percentReal = ((video.duration / 2) / video.duration) * 100
        progressBar.style.flexBasis = `${percentReal}%`
      }
    },

    forceFileDownload(response) {
      console.log('teste', response)
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'file.mp4')
      document.body.appendChild(link)
      link.click()
    },

    download() {
      axios({
        method: 'get',
        url: this.vsl[0].vsl_bucket_address,
        responseType: 'arraybuffer',
      })
        .then(response => {
          this.forceFileDownload(response)
        })
        .catch(() => console.log('error occured'))
    },
    customizacao() {
      this.$router.push(`/player/${this.vslId}/customizacao`)
    },
    analitycs() {
      this.$router.push(`/player/${this.vslId}/analytics`)
    },
    Voltar() {
      this.$router.push({ name: 'Meus-Videos' })
    },
  },
  deleteVSL(vslId) {
    try {
      this.loading = true
      VslService.deleteVsl(vslId).then(response => {
        if (response) {
          //   VslService.getALLVsls().then(response => {
          //         this.vsls = response.data;
          //         this.loading = false;
          //     });
          this.$alert('Comunicação atualizada com sucesso.')
          return this.$router.push('/')
        }
      })
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },

}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/Menu-Lateral-Editar-Video/NavegacaoLateral.scss';
.tb {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 0px;
  border: none;
}

.player {
  max-width: 900px;
  /* //border: 4px solid rgba(0,0,0,.2);
 //box-shadow: 0 0 20px rgba(0,0,0,.2); */
  position: relative;
  font-size: 20;
  overflow: hidden;
}

.player {
  width: 100%;
}

.player:fullcreen {
  max-width: none;
  width: 100%;
}

.player:-webkit-full-screen {
  max-width: none;
  width: 100%;
}

.player:-ms-full-screen {
  max-width: none;
  width: 100%;
}

.player:-moz-full-screen {
  max-width: none;
  width: 100%;
}

.player_my_video {
  min-width: 104%;
  height: 500px;
  /* background: black;
    min-height: 494px; */

}

.player_my_controls {
  display: flex;
  position: absolute;
  bottom: -3px;
  width: 100%;
  transform: translateY(100%) translateY(-16px);
  transition: all .3s;
  flex-wrap: wrap;
  background: rgba(0, 0, 0, .2);
}

.progress_my_filled {
  width: 80%;
  /* //background: #ffc600; */
  background: rgba(255, 226, 40, 0.815);
  flex: 0;
  flex-basis: 0%;
}

.player:hover .player_my_controls {
  transform: translateY(0);
}

.player_my_controls > * {
  flex: 1;
}

.progress {
  flex: 10;
  position: relative;
  display: flex;
  flex-basis: 100%;
  height: 10px;
  transition: height .3s;
  background: rgba(0, 0, 0, .25);
  cursor: pointer;
  /* ew-resize*/
}

.player_my_button {
  background: none;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  outline: 0;
  padding: 10px 15px 10px 15px;
  cursor: pointer;
  max-width: 50px;

}

.playerSlider {
  display: block;
  width: 10px;
  height: 30px;
}

input[type=range] {
  -webkit-appearance: none !important;
  background: transparent;
  width: 100%;
  margin: 0 5px;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 2px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
  background: rgba(255, 255, 255, .8);
  border-radius: 1.3px;
  border: 0.2px solid rgba(1, 1, 1, 0)
}

input[type=range]::-webkit-slider-thumb {
  height: 10px;
  width: 10px;
  border-radius: 50px;
  background: #fff;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -4px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .2);
}

input[type=range]:focus {
  outline: none;

}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: #ff0;

}

/* Mozila Linha do volume*/

input[type=range]::-moz-range-track {
  width: 100%;
  height: 0.1px;
  cursor: pointer;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0), 0 0 1px rgba(13, 13, 13, 0);
  background: #fff;
  border-radius: 1.3px;
  border: 0.2px solid rgba(1, 1, 1, 0)
}

/* Mozila Circulo do volume*/

input[type=range]::-moz-range-thumb {
  height: 10px;
  width: 10px;
  border-radius: 50px;
  border-color: none;
  background: #fff;
  cursor: pointer;
}

.fullscreenbtn {

  margin-left: 75%;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  align-content: stretch;
  outline: 0;
  cursor: pointer;
  max-width: 4px;
}

.button_volume {

  margin-left: -2%;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  align-content: stretch;
  outline: 0;
  cursor: pointer;
  max-width: 4px;
}

.PictureInPicture {
  margin-left: -9%;
  border: 0;
  line-height: 1;
  color: white;
  text-align: center;
  align-content: stretch;
  outline: 0;
  cursor: pointer;
  max-width: 4px;
}

.playpause {

  border-radius: 50px;
  background-image: url(../../Videos/Customizacao/img/play.svg);
  background-repeat: no-repeat;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 10 !important;
}

.playpause {
  opacity: 1;
  transition: opacity 400ms;
}

.playpause[hidden] {
  opacity: 0;

}

.iniciar {
  border: 2px solid;
  border-style: none;
  border-radius: 15px 50px;
  display: block;
  width: 50%;
  height: 42%;
  position: absolute;
  flex-direction: column-reverse;
  display: flex;
  left: 0%;
  right: 0%;
  top: 32%;
  bottom: 10%;
  margin: auto;
  align-items: center;
  background-size: contain;
  background-position: center;

}

.video-banner {
  position: relative;
}

.video-banner .overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  z-index: 1;
}

.loader {
  height: 70px;
  width: 200px;
  display: flex;
  align-items: center;
}

.loader .stroke {
  display: block;
  position: relative;
  background: #f1f1f1;
  height: 50%;
  width: 15%;
  border-radius: 50px;
  margin: 0 5px;
  align-items: center;
  animation: animate 1.2s linear infinite;
}

/* .playImagem {
    width: 64px;
    height: 64px;
    cursor: pointer;
  } */

h2 {
  position: relative;
  align-self: center;
  font-family: Arial, Helvetica, sans-serif;
}

@keyframes animate {
  50% {
    height: 20%;
  }

  100% {
    height: 100%;
  }
}

.stroke:nth-child(1) {
  animation-delay: 0s;
}

.stroke:nth-child(2) {
  animation-delay: 0.3s;
}

.stroke:nth-child(3) {
  animation-delay: 0.6s;
}

.stroke:nth-child(4) {
  animation-delay: 0.9s;
}

.stroke:nth-child(5) {
  animation-delay: 0.6s;
}

.stroke:nth-child(6) {
  animation-delay: 0;
}

.stroke:nth-child(7) {
  animation-delay: 0.2s;
}

.stroke:nth-child(8) {
  animation-delay: 0.5s;
}

.stroke:nth-child(9) {
  animation-delay: 0.1s;
}

.stroke:nth-child(10) {
  animation-delay: 0s;
}

.stroke:nth-child(11) {
  animation-delay: 0.3s;
}

.stroke:nth-child(12) {
  animation-delay: 0.6s;
}

.stroke:nth-child(13) {
  animation-delay: 0.3s;
}

#context-menu {
  position: fixed;
  width: 170px;
  height: 20px;
  border: #000;
  background: rgba(40, 38, 38, 0.856);
  transform: scale(0);
  transform-origin: top left;
  padding: 8px 8px 8px 8px;
}

#context-menu.active {
  transform: scale(1);
  transition: transform 200ms ease-in-out;
}

#context-menu a {
  font-size: 15px;
  font-family: Arial, Helvetica, sans-serif;
  color: #eee;
  text-decoration: none;
}

#context-menu .item:hover {
  background: #555;
}

.playpausebg {

  background-repeat: no-repeat;
  width: 102%;
  height: 128%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 2 !important;
}

.playpausebg {
  opacity: 1;
  transition: opacity 400ms;
}

.playpausebg[hidden] {
  opacity: 0;

}

.playEndedbg {

  background-repeat: no-repeat;
  width: 102%;
  height: 128%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 2 !important;
}

.playEndedbg {
  opacity: 1;
  transition: opacity 400ms;
}

.playEndedbg[hidden] {
  opacity: 0;

}

/*MODAL*/
.item {
  margin: 20px;
  height: 100px;
  width: 110px;
}

#texto {
  color: black;
  height: 214px;
  font-size: large;
  font-family: Verdana;
}

.ant-input {
  box-sizing: border-box;
  margin: 0;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum", "tnum";
  position: relative;
  display: inline-block;
  width: 100%;
  min-width: 0;
  padding: 7px 11px;
  color: rgb(24 8 8 / 85%);
  font-size: 14px;
  line-height: 1.5715;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
}

.Scroll {
  height: 100px;
  overflow-y: scroll;

}

</style>
